<template>
  <div>
    <a
      href="https://www.facebook.com/KorosPrintPack"
      target="_black"
    >
      <VBtn
        fab
        :color="colors[0]"
      >
        <img
          src="@/assets/facebook-logo-white.svg"
          style="height: 24px"
          alt="Favebook logo"
        >
      </VBtn>
    </a>

    <VBtn
      fab
      :color="colors[1]"
      :to="{ name: 'Contact', hash: '#elerhetoseg' }"
    >
      <VIcon
        color="white"
      >
        place
      </VIcon>
    </VBtn>

    <VBtn
      fab
      :color="colors[2]"
      :to="{ name: 'Contact', hash: '#elerhetoseg' }"
    >
      <VIcon
        color="white"
      >
        phone
      </VIcon>
    </VBtn>

    <VBtn
      fab
      :color="colors[3]"
      :to="{ name: 'Contact', hash: '#elerhetoseg' }"
    >
      <VIcon
        :color="colors[3] === '#ffffff' ? '#212121' : 'white'"
      >
        email
      </VIcon>
    </VBtn>
  </div>
</template>

<script>
export default {
  name: 'ContactRow',
  props: {
    colors: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
</style>
